module.exports = __webpack_public_path__ + "img/sm-medium.a55fde23.svg";